module.exports = __webpack_public_path__ + "static/media/tachometer-alt-slow.964437b5.svg";